<div *ngIf="loaded == 1">

    <!--------------------------------------------------------------------------------------- BANNER VISIBLE EN ESCRITORIO UNICAMENTE -->

    <section class="banner pd30  backDark " fxShow="true" fxShow.lt-md="false">
        <div fxLayout="column" fxLayoutAlign="center center" class="fh">

            <div class="cw" fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column" fxLayoutGap="20px">
                <div fxLayout="column" fxLayoutAlign="space-around" fxFlex="50%">
                    <a (click)=regresarCursos() class="gray-3 cursorPointer">Cursos <span class="ft10 gray-3">></span>
                    </a>
                    <h5 class="gray-1a mgb0 zIndex10">{{curso.titulo}} </h5>
                    <h6 class="light-link-color ft300 mgt10 ft16 zIndex10"> {{curso.resumen}} </h6>

                    <div fxLayoutAlign="start center" fxLayoutGap="20px">
                        <img [src]=curso.instructorFoto class="avatar3">
                        <span href="" routerLink="/instructor/{{curso.instructorId}}"
                            class="mgt10 mgb10 chip backGray3 gray-7 cursorPointer">{{curso.instructorNombre}}</span>
                        <span *ngIf="curso.empresaNombre" routerLink="/empresa/{{curso.empresaId}}"
                            class="mgt10 mgb10 chip backGray3 gray-7 cursorPointer">{{curso.empresaNombre}}</span>
                        <span (click)="buscarCategoria()"
                            class="mgt10 mgb10 chip backBlue3 gray-2 cursorPointer">{{curso.categoria}}</span>
                    </div>
                </div>

                <div *ngIf="logged===0" fxLayout="column" fxLayoutAlign="center space-between" fxFlex="25%"
                    class="zIndex1">
                    <button class="mgt20 lightButton grayLink ft500 " (click)="openLogIn()">
                        Inicia sesión para comprar</button>
                </div>
                <div #inscribirse fxLayout="column" fxLayoutAlign="center space-between" fxFlex="25%" class="zIndex1"
                    *ngIf="inscrito===false && logged===1">
                    <button class="mgt20 lightButton grayLink ft500"
                        routerLink="/comprar-curso/{{id}}">Comprar curso</button>
                    <a href="" routerLink="/capacitacion-empresas" class="center fw mgt20 gray-4">¿Entrenamiento para
                        empresas? </a>
                </div>
                <div fxLayout="column" fxLayoutAlign="center space-between" fxFlex="25%" class="zIndex1"
                    *ngIf="inscrito===true && logged===1">
                    <button class="mgt20 lightButton grayLink ft500" routerLink="/est/mi-curso/{{id}}">Ir al
                        curso</button>
                </div>
            </div>

            <div class="imgDestacada"
                [ngStyle]="{ 'background-image': 'linear-gradient(60deg,rgba(21, 27, 38,1) 30%, rgba(21, 27, 38,.1) 100%), url(' + curso.foto + ')'}">
            </div>
        </div>

    </section>

    <!--------------------------------------------------------------------------------------- BANNER VISIBLE EN VERSION MOBILE UNICAMENTE -->

    <section class="backDark pdt20 pdb20" fxShow="false" fxShow.lt-md="true">
        <div class="cw" fxLayout="column" fxLayoutAlign="center center">

            <h5 class="gray-1a mgb0 centertext">{{curso.titulo}} </h5>
            <h6 class="light-link-color ft300 mgt10 ft16 centertext mgb10"> {{curso.resumen}} </h6>

            <div fxLayoutAlign="start center" fxLayoutGap="10px">
                <img [src]=curso.instructorFoto class="avatar2">
                <span href="" routerLink="/instructor/{{curso.instructorId}}"
                    class="mgt10 mgb10 chip backGray3 gray-7 cursorPointer">{{curso.instructorNombre}}</span>
                <span *ngIf="curso.empresaNombre" routerLink="/empresa/{{curso.empresaId}}"
                    class="mgt10 mgb10 chip backGray3 gray-7 cursorPointer">{{curso.empresaNombre}}</span>

            </div>
            <div fxLayout="row" fxLayoutGap="1rem" fxLayout="row" fxLayoutAlign=" center" class="mgt10">
                <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                    <mat-icon class="light-icon-color ft20 linkIcon">attach_money</mat-icon>
                </div>
                <div fxLayout="row" FxLayoutAlign=" center">
                    <span class="center gray-5 ft500 ft16">${{curso.precioFinal}} USD </span>
                    <span *ngIf="curso.precioFinal != curso.precioOriginal" class="mgl10 line-th gray-8 ft16">$
                        {{curso.precioOriginal}} USD</span>
                </div>
            </div>
            <a (click)="buscarCategoria()" class="mgb10">
                <div class="chip backBlue3" fxShow="true" fxShow.lt-md="false">
                    <span class="tagFont">{{curso.categoria}}</span>
                </div>
            </a>
            <div *ngIf="logged===0" fxLayout="column" fxLayoutAlign="center space-between" fxFlex="25%" class="zIndex1">
                <button class="mgt20 lightButton grayLink ft500 " (click)="openLogIn()">
                    Regístrate para inscribirte</button>
            </div>
            <div #inscribirse fxLayout="column" fxLayoutAlign="center space-between" class="zIndex1 fw"
                *ngIf="inscrito===false && logged===1">
                <button class="mgt20 lightButton grayLink ft500 w-100"
                    routerLink="/comprar-curso/{{id}}">Inscribirse</button>
                <a href="" routerLink="/capacitacion-empresas" class="center fw mgt20 gray-4">¿Entrenamiento para
                    empresas? </a>
            </div>
            <div fxLayout="column" fxLayoutAlign="center space-between" fxFlex="25%" class="zIndex1"
                *ngIf="inscrito===true && logged===1">
                <button class="mgt20 lightButton grayLink ft500" routerLink="/est/mi-curso/{{id}}">Ir al
                    curso</button>
            </div>
        </div>
    </section>

    <!-------------------------------------------------------------------------------------- MENU FLOTANTE VISIBLE EN VERSION ESCRITORIO UNICAMENTE-->

    <div class="containerMenuCurso1" [ngClass]=" {'containerMenuCurso2':backColor === 'white'}" id="menu" fxShow="true"
        fxShow.lt-md="false">
        <div class="cw fh" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px"
            *ngIf="backColor==='white'">
            <div fxLayout="row" fxLayoutAlign=" center">
                <mat-icon class="linkIcon ft26 light-icon-color mgr10">bookmark_border</mat-icon>
                <span class="ft14 ft500 dark-font-color">{{curso.titulo}}</span>
            </div>
            <span *ngIf="inscrito == false" class="blue-5">{{fechaTope}}</span>
            <button *ngIf="inscrito == false" class="darkButton" routerLink="/comprar-curso/{{id}}">Inscribirse</button>
            <button *ngIf="inscrito == true" class="darkButton" routerLink="/est/mi-curso/{{id}}">Ir al curso</button>
        </div>
    </div>

    <!------------------------------------------------------------------------------------ INFO RESUMIDA DEL CURSO VISIBLE EN VERSION MOBILE UNICAMENTE -->

    <section id="infoGeneralCurso" ngClass.gt-sm="pdt50" ngClass.lt-md="pdt20">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="2rem" fxLayoutGap.lt-md="0rem" class="cw"
            fxLayout.lt-md="column">

            <div fxLayout="column" fxLayoutAlign="space-between" fxShow="false" fxShow.lt-md="true">

                <div fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="0.625rem">
                    <div fxLayout="row" fxLayoutGap="1rem" fxLayout="row" fxLayoutAlign=" center">
                        <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                            <mat-icon class="light-icon-color ft20 linkIcon">attach_money</mat-icon>
                        </div>
                        <div fxLayout="row" FxLayoutAlign=" center">
                            <span class="center dark-font-color ft500">${{curso.precioFinal}} USD </span>
                            <span *ngIf="curso.precioFinal != curso.precioOriginal" class="mgl10 line-th">$
                                {{curso.precioOriginal}} USD</span>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                        <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                            <mat-icon class="light-icon-color ft20 linkIcon">timer</mat-icon>
                        </div>
                        <div fxLayout="row" FxLayoutAlign=" center">
                            <span>{{curso.duracion/60 | number:'1.0-1'}} horas</span>
                        </div>

                    </div>
                    <div *ngIf="curso.cantArchivos>0" fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                        <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                            <mat-icon class="light-icon-color ft20 linkIcon">attach_file</mat-icon>
                        </div>
                        <div fxLayout="row" FxLayoutAlign=" center">
                            <span>Incluye {{curso.cantArchivos}} archivos descargables</span>
                        </div>

                    </div>

                    <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                        <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                            <mat-icon class="light-icon-color ft20 linkIcon">bookmark</mat-icon>
                        </div>
                        <div fxLayout="row" FxLayoutAlign=" center">
                            <span>Certificado de completación</span>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                        <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                            <mat-icon class="light-icon-color ft20 linkIcon">language</mat-icon>
                        </div>
                        <div fxLayout="row" FxLayoutAlign=" center">
                            <span>Idioma: {{curso.idioma}}</span>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                        <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                            <mat-icon class="light-icon-color ft20 linkIcon"> linear_scale</mat-icon>
                        </div>
                        <div fxLayout="row" FxLayoutAlign=" center">
                            <span>Nivel: {{curso.nivel}}</span>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                        <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                            <mat-icon class="light-icon-color ft20 linkIcon">input</mat-icon>
                        </div>
                        <div fxLayout="row" FxLayoutAlign=" center">
                            <span>Acceso de por vida</span>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutGap="1rem" *ngIf="curso.adicionales[0]!==''">
                        <div fxLayout="row" fxLayoutGap="1rem">
                            <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                                <mat-icon class="light-icon-color ft20 linkIcon">plus_one</mat-icon>
                            </div>
                            <div>
                                <span>Adicionales:</span>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let item of curso.adicionales;  let i=index">
                        <li class="ft12 gray-7 mgb05">{{item}}</li>
                    </div>
                    <br>
                </div>
            </div>



            <!----------------------------------------------------------------------------------------->
            <!-- -------------------------------------------------------------------------------------->
            <!-- -----------------------------------INFO GENERAL DEL CURSO----------------------------->
            <!----------------------------------------------------------------------------------------->
            <!-- -------------------------------------------------------------------------------------->



            <!-- ------------------------------------------------------------------------------------- COLUMNA IZQUIERDA  -->

            <div fxFlex="60%">

                <!-- ------------------------------------------------------------------------------------- INFO GENERAL DEL CURSO -->
                <div *ngIf="mostrarVideo == true" class="videoPreviewContainer">
                    <iframe class="videoPreview" id="myvideo" [src]="safeUrl" (load)="initPlayer()" frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
                    </iframe>
                </div>



                <h6 class="mgb10 ft500 ft17 mgt0">Lo que aprenderás</h6>
                <div *ngFor="let item of curso.queAprenderas;  let i=index">
                    <li>{{item}}</li>
                </div>
                <h6 class="h6Title">Descripción del curso</h6>
                <p class="ft13"> {{curso.descripcion}}</p>
                <h6 class="h6Title">A quién está dirigido</h6>
                <p class="ft13"> {{curso.dirigidoA}}</p>
                <h6 class="h6Title">Contenido del curso</h6>
                <div class="pd05 pdr0 border-t" *ngFor="let item of sesion.clases | slice:0:cantClases;  let i=index"
                    fxLayoutAlign="space-between" fxLayoutGap="1rem">

                    <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="space-between" fxLayoutGap="1rem">
                        <div fxLayout="row" fxLayoutGap="1rem">
                            <div fxLayout="row" fxLayoutAlign="center center">
                                <mat-icon class="iconBorder ft16" *ngIf="item.tipo==='video'">play_arrow
                                </mat-icon>
                                <mat-icon class="iconBorder ft16" *ngIf="item.tipo==='lectura' || item.tipo==='pdf' ">short_text
                                </mat-icon>
                            </div>
                            <p class="mgb0" *ngIf="item.tipo==='video'">
                                <span class="mgb0 mgr05 ft12 gray-6">{{i + 1}}.</span>
                                Video - {{item.titulo}}
                            </p>
                            <p class="mgb0" *ngIf="item.tipo==='lectura' || item.tipo==='pdf' " >
                                <span class="mgb0 mgr05 ft12 gray-6">{{i + 1}}.</span>
                                Lectura - {{item.titulo}}
                            </p>
                            
                        </div>
                        <p class="mgb0 ft12 gray-6 nowrap"> {{item.duracion}} min</p>
                    </div>
                </div>
                <div class="border-t pd05 cursorPointer" fxLayoutAlign="center" *ngIf="botonVerMas == true">
                    <a *ngIf="verMasFlag == false" (click)="verMas()" class="blue-5"> Ver mas</a>
                    <a *ngIf="verMasFlag == true" (click)="verMenos()" class="blue-5"> Ver menos</a>
                </div>

                <!-- ------------------------------------------------------------------------------------- INFO INSTRUCTOR -->

                <div class="pdt05 fw" fxLayout="column">
                    <h6 class="h6Title">Instructor</h6>
                    <div fxLayout="row" fxLayoutGap="1rem">
                        <img [src]=curso.instructorFoto class="avatar5 mgb10">
                        <div fxLayout="column" fxLayoutAlign="center">
                            <a class="gray-9 ft500"> {{curso.instructorNombre}} </a>
                            <p class="ft13 ft400 light-icon-color">{{curso.instructorResumen}}</p>
                        </div>
                    </div>

                    <p class="ft12">{{curso.instructorDescripcion}} </p>
                    <a routerLink="/instructor/{{curso.instructorId}}" class="grayLink ft12">
                        <div fxLayout="row" fxLayoutAlign=" center">
                            <span class="ft400 ft12 blueLink ft500">Ver perfil de instructor</span>
                            <mat-icon class="mgl05 ft16 linkIcon blueLink"> arrow_forward </mat-icon>
                        </div>
                    </a>
                </div>

                <!-- ------------------------------------------------------------------------------------- INFO EMPRESA -->

                <div class="pdt05 fw mgb40" fxLayout="column">
                    <h6 *ngIf="curso.empresaNombre" class="h6Title">Empresa</h6>
                    <div *ngIf="curso.empresaNombre" fxLayout="row" fxLayoutGap="1rem">
                        <img [src]=curso.empresaFoto class="avatarSquare5 mgb10">
                        <div fxLayout="column" fxLayoutAlign="center">
                            <a class="gray-9 ft500"> {{curso.empresaNombre}} </a>
                            <p class="ft13 ft400 light-icon-color">{{curso.empresaResumen}}</p>
                        </div>
                    </div>

                    <p *ngIf="curso.empresaNombre" class="ft12"> {{curso.empresaDescripcion}} </p>
                    <a *ngIf="curso.empresaNombre" routerLink="/empresa/{{curso.empresaId}}" class="grayLink ft12">
                        <div fxLayoutAlign=" center">
                            <span class="ft400 ft12 blueLink ft500">Ver perfil de empresa</span>
                            <mat-icon class="mgl05 ft16 linkIcon blueLink"> arrow_forward </mat-icon>
                        </div>
                    </a>
                </div>

            </div>

            <!-- ------------------------------------------------------------------------------------- COLUMNA DERECHA -->

            <div fxFlex="30%">

                <!-- ------------------------------------------------------------------------------------- INFO RESUMIDA DEL CURSO Y ADICIONALES -->

                <div fxLayout="column" fxLayoutAlign="space-between" fxShow="true" fxShow.lt-md="false">

                    <div fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="0.625rem">
                        <div fxLayout="row" fxLayoutGap="1rem" fxLayout="row" fxLayoutAlign=" center">
                            <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                                <mat-icon class="light-icon-color ft20 linkIcon">attach_money</mat-icon>
                            </div>
                            <div fxLayout="row" FxLayoutAlign=" center">
                                <span class="center dark-font-color ft500">${{curso.precioFinal}} USD </span>
                                <span *ngIf="curso.precioFinal != curso.precioOriginal" class="mgl10 line-th">$
                                    {{curso.precioOriginal}} USD</span>
                            </div>
                        </div>

                        <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                            <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                                <mat-icon class="light-icon-color ft20 linkIcon">timer</mat-icon>
                            </div>
                            <div fxLayout="row" FxLayoutAlign=" center">
                                <span>{{curso.duracion/60 | number:'1.0-1'}} horas</span>
                            </div>

                        </div>

                        <div *ngIf="curso.cantArchivos>0" fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                            <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                                <mat-icon class="light-icon-color ft20 linkIcon">attach_file</mat-icon>
                            </div>
                            <div fxLayout="row" FxLayoutAlign=" center">
                                <span>Incluye {{curso.cantArchivos}} archivos descargables</span>
                            </div>

                        </div>

                        <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                            <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                                <mat-icon class="light-icon-color ft20 linkIcon">bookmark</mat-icon>
                            </div>
                            <div fxLayout="row" FxLayoutAlign=" center">
                                <span>Certificado de completación</span>
                            </div>
                        </div>

                        <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                            <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                                <mat-icon class="light-icon-color ft20 linkIcon">language</mat-icon>
                            </div>
                            <div fxLayout="row" FxLayoutAlign=" center">
                                <span>Idioma: {{curso.idioma}}</span>
                            </div>
                        </div>

                        <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                            <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                                <mat-icon class="light-icon-color ft20 linkIcon"> linear_scale</mat-icon>
                            </div>
                            <div fxLayout="row" FxLayoutAlign=" center">
                                <span>Nivel: {{curso.nivel}}</span>
                            </div>
                        </div>

                        <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign=" center">
                            <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                                <mat-icon class="light-icon-color ft20 linkIcon">input</mat-icon>
                            </div>
                            <div fxLayout="row" FxLayoutAlign=" center">
                                <span>Acceso de por vida</span>
                            </div>
                        </div>

                        <div fxLayout="row" fxLayoutGap="1rem" *ngIf="curso.adicionales[0]!==''">
                            <div fxLayout="row" fxLayoutGap="1rem">
                                <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderM">
                                    <mat-icon class="light-icon-color ft20 linkIcon">plus_one</mat-icon>
                                </div>
                                <div>
                                    <span>Adicionales:</span>
                                </div>
                            </div>
                        </div>
                        <div *ngFor="let item of curso.adicionales;  let i=index">
                            <li class="ft12 gray-7 mgb05">{{item}}</li>
                        </div>
                    </div>
                </div>


                <!-- ------------------------------------------------------------------------------------- VALORACION DEL CURSO -->

                <h6 class="h6Title">Valoración del curso &nbsp;</h6>
                <p class="gray-7" *ngIf="valoraciones.length==0">Este curso aun no cuenta con suficientes valoraciones
                    para
                    mostrar.</p>

                <div *ngIf="valoraciones.length>0">
                    <p class="mgb05">Valoracion global del curso </p>
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1rem">
                        <mat-progress-bar mode="determinate" [value]="valGlobal*20"></mat-progress-bar>
                        <span class="ft11 gray-6">{{valGlobal | number: '1.0-1'}}</span>
                    </div>
                    <p class="mgb05">Material del curso </p>
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1rem">
                        <mat-progress-bar mode="determinate" [value]="valMaterial*20"></mat-progress-bar>
                        <span class="ft11 gray-6">{{valMaterial | number: '1.0-1'}}</span>
                    </div>
                    <p class="mgb05">Nivel del instructor</p>
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1rem">
                        <mat-progress-bar mode="determinate" [value]="valInstructor*20"></mat-progress-bar>
                        <span class="ft11 gray-6">{{valInstructor | number: '1.0-1'}}</span>
                    </div>
                    <p class="mgb05">Conocimientos adquiridos</p>
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1rem">
                        <mat-progress-bar mode="determinate" [value]="valConocimientos*20"></mat-progress-bar>
                        <span class="ft11 gray-6">{{valConocimientos | number: '1.0-1'}}</span>
                    </div>
                    <h6 class="h6Title">Comentarios destacados</h6>

                    <!-- Comentarios  -->
                    <div fxLayout="row" *ngFor="let item of valoraciones | slice:0:4;  let i=index"
                        class="mgb20 shadow8 pdt08 pdr08 pdl08 pdb05 radius3 border">
                        <img [src]=item.usuarioPhotoURL class="avatar2">
                        <div class="mgl10">
                            <p class="mgb0 ft11">{{item.valoracion.comentario}}</p>
                            <p class="mgt05 mgb0 ft10 ft500">{{item.usuarioNombreCompleto}}</p>
                            <p class="mgb0 ft10">{{item.valoracion.fecha}} </p>
                            <div>
                                <ngb-rating [(rate)]="item.valoracion.global" [max]="5" [readonly]="true">
                                    <ng-template let-fill="fill">
                                        <span [class.filled]="fill === 100" [class.notfilled]="fill === 0"
                                            class="mgr05 ft22">
                                            &#9733;
                                        </span>
                                    </ng-template>
                                </ngb-rating>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <!-- ------------------------------------------------------------------------------------- CURSOS RELACIONADOS -->

        <div class="cw">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div>
                    <h6 class="h6Title mgb0">Cursos relacionados</h6>
                    <a routerLink="/buscar" class="grayLink mgt30 mgb20">
                        <div fxLayoutAlign=" center">
                            <span fxShow="true" fxShow.lt-md="false" class="ft400 ft12 blueLink ft500">Explorar más
                                cursos</span>
                            <span fxShow="false" fxShow.lt-md="true" class="ft400 ft14 blueLink ft500">Explorar cursos
                                relacionados</span>
                            <mat-icon class="mgl05 ft16 linkIcon blueLink"> arrow_forward </mat-icon>
                        </div>
                    </a>
                    <br>
                </div>
            </div>
        </div>

        <div class="cw" fxShow="true" fxShow.lt-md="false">
            <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="1.5rem" fxLayoutAlign="space-between"
                ngClass.gt-sm="containerGrid" ngClass.lt-sm="containerGridSm" class="mgb20">
                <div class="cursoCard radius3" *ngFor="let item of cursosRelacionados | slice:0:4;  let i=index"
                    (mouseover)="mostrarInfo=i" (mouseout)="mostrarInfo=-1" fxLayout="column">
                    <a href="curso/{{item.id}}">
                        <div class="cardImage1" [ngClass]=" {'cardImage2':mostrarInfo === i}"
                            [ngStyle]="{ 'background-image': 'url(' + item.foto + ')'}">
                        </div>
                        <div class="pd08">
                            <p class="default-font-color ft500 ft11 mgb05" href="">{{item.titulo}}</p>
                            <p class="cardInfoText1 default-font-color ft10 mgb0"
                                [ngClass]=" {'cardInfoText2':mostrarInfo === i}" fxShow.lt-sm="false" fxShow="true">
                                {{item.resumen}}
                            </p>
                        </div>
                    </a>
                    <div class="pd08 cardAuthor" fxLayout="row" fxLayoutAlign="space-between center">
                        <div>
                            <img [src]=item.instructorFoto class="avatar2">
                            <a class="author default-font-color ft11">{{item.instructorNombre}}</a>
                        </div>
                        <div>
                            <a class="dark-font-color ft500 ft11">${{item.precioFinal}} USD</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="cw" fxShow="false" fxShow.lt-md="true">
            <div *ngFor="let item of cursosRelacionados | slice:0:4;  let i=index">
                <a href="curso/{{item.id}}">
                    <div ngClass.lt-md="mgt20 mgb10 border radius3 shadow8" fxLayout="row" fxLayoutAlign="space-between"
                        fxLayoutGap="2rem" class="cursorPointer">
                        <div fxLayout="row" fxLayoutGap="1rem" fxFlex="90%" fxFlex.lt-md="100%">
                            <img [src]=item.foto class="fotoDestacada2">
                            <div class="pdt08 pdb10">
                                <h6 class="ft13 ft500 mgt0 mgb0 mgr05">
                                    {{item.titulo}}
                                </h6>
                                <p class="mgt0 mgb0 ft11 mgr05">{{item.resumen}} </p>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

    </section>

</div>

<div *ngIf="loaded == 0">
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</div>